import React from 'react'
import { Skeleton as SkeletonPrime } from 'primereact/skeleton'
/**
 * @param {import("primereact/skeleton").SkeletonProps} props
 * @returns
 */
export function Skeleton (props) {
  return <SkeletonPrime {...props} />
}
